import gql from 'graphql-tag'
import client from '@stores/apollo'
import { IFile, IAsset } from '@api'

const add = (id: string, files: (IFile | IAsset)[]) => {
  return client.gql.mutate({
    mutation: addMutation,
    variables: { input: { contractId: id, files } },
  })
}

const remove = (assetId: string) => {
  return client.gql.mutate({
    mutation: deleteMutation,
    variables: { input: { id: assetId } },
  })
}

export default { add, remove }

const addMutation = gql`
  mutation AddContractAssets($input: AddContractAssetsInput!) {
    addContractAssets(input: $input) {
      contractAssets {
        id
      }
    }
  }
`

const deleteMutation = gql`
  mutation DeleteContractAsset($input: DeleteContractAssetInput!) {
    deleteContractAsset(input: $input) {
      contractAsset {
        id
      }
    }
  }
`
